import e, { useState as n } from "react";
import r from "prop-types";
import { css as o, cx as t } from "@leafygreen-ui/emotion";
import a from "@leafygreen-ui/icon/dist/Checkmark";
import i from "@leafygreen-ui/icon/dist/CheckmarkWithCircle";
import l from "@leafygreen-ui/icon/dist/Warning";
import { useIdAllocator as d, useValidation as s } from "@leafygreen-ui/hooks";
import { useUpdatedBaseFontSize as c, Label as p, Description as b } from "@leafygreen-ui/typography";
import { BaseFontSize as g, fontFamilies as h, typeScales as u } from "@leafygreen-ui/tokens";
import { createUniqueClassName as f, Theme as y } from "@leafygreen-ui/lib";
import { palette as m } from "@leafygreen-ui/palette";
import { useDarkMode as x } from "@leafygreen-ui/leafygreen-provider";
import { jsx as v } from "@emotion/react";

function w(e, n) {
  var r = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function (n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), r.push.apply(r, o);
  }

  return r;
}

function k(e) {
  for (var n = 1; n < arguments.length; n++) {
    var r = null != arguments[n] ? arguments[n] : {};
    n % 2 ? w(Object(r), !0).forEach(function (n) {
      O(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : w(Object(r)).forEach(function (n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }

  return e;
}

function O(e, n, r) {
  return n in e ? Object.defineProperty(e, n, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = r, e;
}

function j() {
  return j = Object.assign || function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var r = arguments[n];

      for (var o in r) {
        Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
      }
    }

    return e;
  }, j.apply(this, arguments);
}

function S(e, n) {
  if (null == e) return {};

  var r,
      o,
      t = function (e, n) {
    if (null == e) return {};
    var r,
        o,
        t = {},
        a = Object.keys(e);

    for (o = 0; o < a.length; o++) {
      r = a[o], n.indexOf(r) >= 0 || (t[r] = e[r]);
    }

    return t;
  }(e, n);

  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);

    for (o = 0; o < a.length; o++) {
      r = a[o], n.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (t[r] = e[r]);
    }
  }

  return t;
}

function z(e, n) {
  return n || (n = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(n)
    }
  }));
}

function N(e, n) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, n) {
    var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null == r) return;
    var o,
        t,
        a = [],
        i = !0,
        l = !1;

    try {
      for (r = r.call(e); !(i = (o = r.next()).done) && (a.push(o.value), !n || a.length !== n); i = !0) {
        ;
      }
    } catch (e) {
      l = !0, t = e;
    } finally {
      try {
        i || null == r.return || r.return();
      } finally {
        if (l) throw t;
      }
    }

    return a;
  }(e, n) || function (e, n) {
    if (!e) return;
    if ("string" == typeof e) return D(e, n);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    "Object" === r && e.constructor && (r = e.constructor.name);
    if ("Map" === r || "Set" === r) return Array.from(e);
    if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return D(e, n);
  }(e, n) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function D(e, n) {
  (null == n || n > e.length) && (n = e.length);

  for (var r = 0, o = new Array(n); r < n; r++) {
    o[r] = e[r];
  }

  return o;
}

var P,
    C,
    L,
    E,
    M,
    V,
    I,
    T,
    A,
    F,
    B,
    X,
    H,
    U,
    W,
    q,
    R,
    Y,
    $,
    G,
    J,
    K,
    Q,
    Z,
    _,
    ee,
    ne,
    re,
    oe,
    te,
    ae,
    ie,
    le,
    de,
    se,
    ce,
    pe,
    be,
    ge,
    he,
    ue,
    fe,
    ye,
    me,
    xe,
    ve,
    we = {
  None: "none",
  Valid: "valid",
  Error: "error"
},
    ke = {
  Email: "email",
  Password: "password",
  Search: "search",
  Text: "text",
  Url: "url",
  Tel: "tel",
  Number: "number"
},
    Oe = {
  XSmall: "xsmall",
  Small: "small",
  Default: "default",
  Large: "large"
},
    je = k(k({}, g), {}, {
  Large: 18
}),
    Se = f("icon-selector"),
    ze = o(P || (P = z(["\n  font-family: ", ";\n  display: flex;\n  flex-direction: column;\n"])), h.default),
    Ne = function Ne(e, n) {
  switch (e) {
    case Oe.XSmall:
      return o(C || (C = z(["\n        font-size: ", "px;\n        line-height: ", "px;\n      "])), u.body1.fontSize, u.body1.lineHeight);

    case Oe.Small:
      return o(L || (L = z(["\n        font-size: ", "px;\n        line-height: ", "px;\n      "])), u.body1.fontSize, u.body1.lineHeight);

    case Oe.Large:
      return o(E || (E = z(["\n        font-size: 18px;\n        line-height: 32px;\n      "])));

    default:
      var r = n == g.Body1 ? u.body1 : u.body2;
      return o(M || (M = z(["\n        font-size: ", "px;\n        line-height: ", "px;\n      "])), r.fontSize, r.lineHeight);
  }
},
    De = o(V || (V = z(["\n  font-size: inherit;\n  line-height: inherit;\n"]))),
    Pe = o(I || (I = z(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  padding-top: 4px;\n  z-index: 0;\n"]))),
    Ce = o(T || (T = z(["\n  ", ";\n  font-family: ", ";\n  width: 100%;\n  height: 36px;\n  font-weight: normal;\n  border: 1px solid;\n  z-index: 1;\n  outline: none;\n  border-radius: 6px;\n  transition: 150ms ease-in-out;\n  transition-property: border-color, box-shadow;\n\n  &:disabled {\n    cursor: not-allowed;\n\n    &:hover,\n    &:active {\n      box-shadow: none;\n    }\n  }\n\n  &::placeholder {\n    ", ";\n  }\n\n  /* clears the ‘X’ from Internet Explorer & Chrome */\n  &[type='search'] {\n    &::-ms-clear,\n    &::-ms-reveal {\n      display: none;\n      width: 0;\n      height: 0;\n    }\n    &::-webkit-search-decoration,\n    &::-webkit-search-cancel-button,\n    &::-webkit-search-results-button,\n    &::-webkit-search-results-decoration {\n      display: none;\n    }\n  }\n"])), De, h.default, De),
    Le = (O(B = {}, y.Light, o(A || (A = z(["\n    color: ", ";\n    background-color: ", ";\n    border: 1px solid ", ";\n\n    &:-webkit-autofill {\n      border: 1px solid ", ";\n      color: ", ";\n      background: ", ";\n      -webkit-text-fill-color: ", ";\n      box-shadow: 0 0 0 1000px ", " inset;\n\n      &:focus {\n        box-shadow: 0 0 0 1000px ", " inset,\n          0 0 0 2px ", ";\n        border-color: ", ";\n      }\n\n      &:hover:not(:focus) {\n        box-shadow: 0 0 0 1000px ", " inset,\n          0 0 0 3px ", ";\n      }\n    }\n\n    &::placeholder {\n      color: ", ";\n      font-weight: normal;\n    }\n\n    &:hover,\n    &:active {\n      box-shadow: 0 0 0 3px ", ";\n    }\n\n    &:disabled {\n      color: ", ";\n      background-color: ", ";\n      border-color: ", ";\n\n      &::placeholder {\n        color: inherit;\n      }\n\n      &:-webkit-autofill {\n        &,\n        &:hover,\n        &:focus {\n          appearance: none;\n          border: 1px solid ", ";\n          -webkit-text-fill-color: ", ";\n          box-shadow: 0 0 0px 1000px ", " inset;\n        }\n      }\n    }\n  "])), m.black, m.white, m.gray.base, m.gray.base, m.black, m.white, m.black, m.white, m.white, m.blue.light1, m.blue.light1, m.white, m.gray.light2, m.gray.light1, m.gray.light2, m.gray.base, m.gray.light2, m.gray.light1, m.gray.base, m.gray.base, m.gray.light2)), O(B, y.Dark, o(F || (F = z(["\n    color: ", ";\n    background-color: ", ";\n    border: 1px solid ", ";\n\n    &:-webkit-autofill {\n      border: 1px solid ", ";\n      color: ", ";\n      background: ", ";\n      -webkit-text-fill-color: ", ";\n      box-shadow: 0 0 0 1000px ", " inset;\n\n      &:focus {\n        box-shadow: 0 0 0 1000px ", " inset,\n          0 0 0 2px ", ";\n        border-color: ", ";\n      }\n\n      &:hover:not(:focus) {\n        box-shadow: 0 0 0 1000px ", " inset,\n          0 0 0 3px ", ";\n      }\n    }\n\n    &:hover,\n    &:active {\n      box-shadow: 0 0 0 3px ", ";\n    }\n\n    &::placeholder {\n      color: ", ";\n      font-weight: normal;\n    }\n\n    &:disabled {\n      color: ", ";\n      background-color: ", ";\n      border-color: ", ";\n\n      &::placeholder {\n        color: inherit;\n      }\n\n      &:-webkit-autofill {\n        &,\n        &:hover,\n        &:focus {\n          appearance: none;\n          border: 1px solid ", ";\n          -webkit-text-fill-color: ", ";\n          box-shadow: 0 0 0px 1000px ", " inset;\n        }\n      }\n    }\n  "])), m.gray.light3, m.gray.dark4, m.gray.base, m.gray.base, m.gray.light3, m.gray.dark4, m.gray.light3, m.gray.dark4, m.gray.dark4, m.blue.light1, m.blue.light1, m.gray.dark4, m.gray.dark2, m.gray.dark2, m.gray.base, m.gray.dark1, m.gray.dark3, m.gray.dark2, m.gray.dark1, m.gray.dark1, m.gray.dark2)), B),
    Ee = o(X || (X = z(["\n  &:focus {\n    border-color: ", ";\n    box-shadow: 0 0 0 2px ", ";\n  }\n"])), m.blue.light1, m.blue.light1),
    Me = (O(R = {}, Oe.XSmall, o(H || (H = z(["\n    height: 22px;\n    padding-left: 10px;\n  "])))), O(R, Oe.Small, o(U || (U = z(["\n    height: 28px;\n    padding-left: 10px;\n  "])))), O(R, Oe.Default, o(W || (W = z(["\n    height: 36px;\n    padding-left: 12px;\n  "])))), O(R, Oe.Large, o(q || (q = z(["\n    height: 48px;\n    padding-left: 16px;\n  "])))), R),
    Ve = (O(ne = {}, we.Valid, (O(G = {}, y.Light, o(Y || (Y = z(["\n      &:not(:disabled) {\n        border-color: ", ";\n\n        &:hover,\n        &:active {\n          box-shadow: 0 0 0 3px ", ";\n        }\n      }\n    "])), m.green.dark1, m.green.light2)), O(G, y.Dark, o($ || ($ = z(["\n      &:not(:disabled) {\n        border-color: ", ";\n\n        &:hover,\n        &:active {\n          box-shadow: 0 0 0 3px ", ";\n        }\n      }\n    "])), m.green.dark1, m.green.dark3)), G)), O(ne, we.Error, (O(Q = {}, y.Light, o(J || (J = z(["\n      &:not(:disabled) {\n        border-color: ", ";\n\n        &:hover,\n        &:active {\n          box-shadow: 0 0 0 3px ", ";\n        }\n      }\n    "])), m.red.base, m.red.light2)), O(Q, y.Dark, o(K || (K = z(["\n      &:not(:disabled) {\n        border-color: ", ";\n\n        &:hover,\n        &:active {\n          // Yes, yellow\n          box-shadow: 0 0 0 3px ", ";\n        }\n      }\n    "])), m.red.light1, m.yellow.dark3)), Q)), O(ne, we.None, (O(ee = {}, y.Light, o(Z || (Z = z([""])))), O(ee, y.Dark, o(_ || (_ = z([""])))), ee)), ne),
    Ie = o(re || (re = z(["\n  position: absolute;\n  display: flex;\n  align-items: center;\n  z-index: 1;\n"]))),
    Te = (O(le = {}, Oe.XSmall, o(oe || (oe = z(["\n    right: 10px;\n  "])))), O(le, Oe.Small, o(te || (te = z(["\n    right: 10px;\n  "])))), O(le, Oe.Default, o(ae || (ae = z(["\n    right: 12px;\n  "])))), O(le, Oe.Large, o(ie || (ie = z(["\n    right: 16px;\n  "])))), le),
    Ae = (O(he = {}, we.Valid, (O(ce = {}, y.Light, o(de || (de = z(["\n      color: ", ";\n    "])), m.green.dark1)), O(ce, y.Dark, o(se || (se = z(["\n      color: ", ";\n    "])), m.green.base)), ce)), O(he, we.Error, (O(ge = {}, y.Light, o(pe || (pe = z(["\n      color: ", ";\n    "])), m.red.base)), O(ge, y.Dark, o(be || (be = z(["\n      color: ", ";\n    "])), m.red.light1)), ge)), he),
    Fe = o(ue || (ue = z(["\n  font-size: 12px;\n  font-style: italic;\n  font-weight: normal;\n  color: ", "; // Same in light & dark theme\n"])), m.gray.dark1),
    Be = o(fe || (fe = z(["\n  ", ";\n  min-height: 20px;\n  padding-top: 4px;\n  font-weight: normal;\n"])), De),
    Xe = (O(xe = {}, y.Light, o(ye || (ye = z(["\n    color: ", ";\n  "])), m.red.base)), O(xe, y.Dark, o(me || (me = z(["\n    color: ", ";\n  "])), m.red.light1)), xe),
    He = ["label", "description", "onChange", "onBlur", "placeholder", "errorMessage", "optional", "disabled", "state", "type", "id", "value", "className", "darkMode", "sizeVariant", "aria-labelledby", "handleValidation", "baseFontSize"],
    Ue = e.forwardRef(function (e, r) {
  var g = e.label,
      h = e.description,
      u = e.onChange,
      f = e.onBlur,
      y = e.placeholder,
      m = e.errorMessage,
      w = e.optional,
      k = void 0 !== w && w,
      D = e.disabled,
      P = void 0 !== D && D,
      C = e.state,
      L = void 0 === C ? we.None : C,
      E = e.type,
      M = void 0 === E ? ke.Text : E,
      V = e.id,
      I = e.value,
      T = e.className,
      A = e.darkMode,
      F = e.sizeVariant,
      B = void 0 === F ? Oe.Default : F,
      X = e["aria-labelledby"],
      H = e.handleValidation,
      U = e.baseFontSize,
      W = S(e, He),
      q = x(A),
      R = q.darkMode,
      Y = q.theme,
      $ = "string" == typeof I,
      G = N(n(""), 2),
      J = G[0],
      K = G[1],
      Q = $ ? I : J,
      Z = d({
    prefix: "textinput",
    id: V
  }),
      _ = c(U),
      ee = s(H);

  "search" === M || g || X || console.error("For screen-reader accessibility, label or aria-labelledby must be provided to TextInput."), "search" !== M || W["aria-label"] || console.error("For screen-reader accessibility, aria-label must be provided to TextInput.");
  var ne = R ? i : a;
  return v("div", {
    className: t(ze, Ne(B, _), T)
  }, g && v(p, {
    darkMode: R,
    htmlFor: Z,
    disabled: P,
    className: De
  }, g), h && v(b, {
    darkMode: R,
    disabled: P,
    className: De
  }, h), v("div", {
    className: Pe
  }, v("input", j({}, W, {
    "aria-labelledby": X,
    type: M,
    className: t(Ce, Le[Y], Me[B], Ve[L][Y], Ee, O({}, o(ve || (ve = z(["\n                    padding-right: 60px;\n                  "]))), k && !P)),
    value: Q,
    required: !k,
    disabled: P,
    placeholder: y,
    onChange: function onChange(e) {
      u && u(e), $ || K(e.target.value), ee.onChange(e);
    },
    onBlur: function onBlur(e) {
      f && f(e), ee.onBlur(e);
    },
    ref: r,
    id: Z,
    autoComplete: P ? "off" : (null == W ? void 0 : W.autoComplete) || "on",
    "aria-invalid": "error" === L
  })), v("div", {
    className: t(Se, Ie, Te[B])
  }, L === we.Valid && v(ne, {
    role: "presentation",
    className: Ae.valid[Y]
  }), L === we.Error && v(l, {
    role: "presentation",
    className: Ae.error[Y]
  }), L === we.None && !P && k && v("div", {
    className: Fe
  }, v("p", null, "Optional")))), L === we.Error && m && v("div", {
    className: t(Be, Xe[Y])
  }, v("span", null, m)));
});

Ue.displayName = "TextInput", Ue.propTypes = {
  id: r.string,
  label: r.string,
  description: r.string,
  optional: r.bool,
  disabled: r.bool,
  onChange: r.func,
  placeholder: r.string,
  errorMessage: r.string,
  state: r.oneOf(Object.values(we)),
  value: r.string,
  className: r.string,
  sizeVariant: r.oneOf(Object.values(Oe)),
  baseFontSize: r.oneOf(Object.values(g))
};
export { Oe as SizeVariant, we as State, je as TextInputFontSize, ke as TextInputType, Ue as default };